

const getTypeLabel = (type: string) => {
  switch (type) {
    case "WAREHOUSE":
      return "Warehouse"
    case "STORE":
      return "Store"
    case "DROP_SHIP":
      return "Drop ship"
    case "INBOUND":
      return "Inbound"
    default:
      return type
  }
}

export const getTypeOptions = () =>
  ["WAREHOUSE", "STORE", "DROP_SHIP", "INBOUND"].map((type) => ({
    label: getTypeLabel(type),
    value: type
  }))
